import axios from 'axios';
import { authService } from 'services/auth/auth_service';

const BASE_API_URL = process.env.REACT_APP_URL_API ?? '';
const API_URL_USERS = BASE_API_URL + '/users/profiles';
const API_URL_INSTITUTIONS = BASE_API_URL + '/institutions/profiles';


export const getProfilesDropdown = async (groupUuid?: string): Promise<any> => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.get(`${API_URL_USERS}`, {
    params: groupUuid ? { groupUuid } : {},
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};



export const getInstitutionProfilesDropdown = async (groupUuid?: string): Promise<any> => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.get(`${API_URL_INSTITUTIONS}`, {
    params: groupUuid ? { groupUuid } : {},
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};